import { render, staticRenderFns } from "./OzBaseButton.vue?vue&type=template&id=0f7134f3&"
import script from "./OzBaseButton.vue?vue&type=script&lang=ts&"
export * from "./OzBaseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports